import React from "react";
import Modal from "../../shared/create-offer/Modal/Modal";
import FaceIdIcon from "../../../offers/img/create-offers/face-id.svg";
import WhatsappIcon from "../../../offers/img/create-offers/whatsapp.svg";


export const OfertaEmVendaModal = ({ show, onConfirm }) => {
	return (
		<Modal
			show={show}
			fixed={true}
			title="Oferta em venda"
			description="Neste momento estamos utilizando suas milhas para a emissão de uma passagem. Portanto, não é possível editar a oferta."
			confirm="Ok, entendi"
			onConfirm={onConfirm}
		/>
	);
};
export const LatamFacialAuthRequiredModal = ({ show, width = 586, onCancel, onConfirm }) => {
	return (
		<Modal
			show={show}
			fixed={true}
			width={width}
			height={645}
			title="<h3>Reconhecimento Facial</h3>"
			description={`
				<p style='display: flex; justify-content: space-between; align-items: center; width: 70%; margin: 0 auto;'>
					<img style='margin: 0 auto 48px;' src='${FaceIdIcon}'/>
				</p>
				<p>
					<b>A Latam Pass</b> pode exigir reconhecimento facial nas emissões de passagens aéreas.
				</p>
				<p>A cada emissão, você poderá receber uma mensagem da Maxmilhas no seu WhatsApp com um link para realizar o processo de reconhecimento facial diretamente no site da LatamPass/UNICO e concluir a emissão da passagem.</p>
				<p style='display: flex; justify-content: space-between; align-items: center; border: 1px solid #505c77; border-radius: 8px; padding: 16px 8px; margin-top: 16px;'>
					<span style='flex: 1;'>
						<img src='${WhatsappIcon}'/>
						<b>WhatsApp oficial</b>
						</span>
						<span style='flex: 1; text-align: right'>+55 (31) 2342-0016</span>
				</p>
			`}
			confirm="Estou ciente"
			onConfirm={onConfirm}
		/>
	);
};

export const EditarNaoElegivel = ({ show, onCancel, onConfirm }) => {
	return (
		<Modal
			show={show}
			fixed={true}
			title="ATENÇÃO"
			description="A edição da sua oferta o tornará inelegível ao Venda Rápida. Tem certeza que deseja continuar?"
			cancel="Cancelar"
			confirm="Continuar"
			onCancel={onCancel}
			onConfirm={onConfirm}
			dataActionConfirm="quick-sale-modal-not-valid-confirm"
			dataActionCancel="quick-sale-modal-not-valid-cancel"
		/>
	);
};

export const EditarNaoElegivelPagamentoAntecipado = ({ show, onCancel, onConfirm }) => {
	return (
		<Modal
			show={show}
			fixed={true}
			title="ATENÇÃO"
			description="A edição da sua oferta o tornará inelegível ao Pagamento Agendado. Tem certeza que deseja continuar?"
			cancel="Cancelar"
			confirm="Continuar"
			onCancel={onCancel}
			onConfirm={onConfirm}
			dataActionConfirm="quick-sale-modal-not-valid-confirm"
			dataActionCancel="quick-sale-modal-not-valid-cancel"
		/>
	);
};

export const EditarPerderBonus = ({ show, onCancel, onConfirm }) => {
	return (
		<Modal
			show={show}
			fixed={true}
			title="ATENÇÃO"
			description="A edição da sua oferta poderá tirar a elegibilidade do bônus. Tem certeza que deseja continuar?"
			cancel="Cancelar"
			confirm="Continuar"
			onCancel={onCancel}
			onConfirm={onConfirm}
			dataActionConfirm="bonus-modal-not-valid-confirm"
			dataActionCancel="bonus-modal-not-valid-cancel"
		/>
	);
};

export const EditarOfertaModal = ({ show, onConfirm, onCancel, isQuickSale, isForwardPayment }) => {
	return (
		<Modal
			show={show}
			fixed={true}
			title="Atenção"
			description={
				(isQuickSale || isForwardPayment)
					? "<p>Sua média de milhas por passageiro pode ser redefinida automaticamente, de acordo com a quantidade de milhas da sua oferta.</p>"
					: "<p>Quando você faz a edição de uma oferta, nosso sistema passa a reconhecê-la como nova e desconsidera o histórico das emissões realizadas até o momento da edição.</p><p>Deseja continuar?</p>"
			}
			confirm={(isQuickSale || isForwardPayment) ? "Aceitar" : "Continuar"}
			cancel="Cancelar"
			width={490}
			onConfirm={onConfirm}
			onCancel={onCancel}
		/>
	);
};

export const CriarOfertaModal = ({ show, onConfirm, onCancel }) => {
	return (
		<Modal
			show={show}
			fixed={true}
			title="Confirme o telefone cadastrado"
			description="Antes de finalizar sua oferta, você deve confirmar se o telefone da sua conta Latam Pass é o mesmo informado neste cadastro.</br></br>Lembramos que o Latam Pass envia um SMS para esse telefone a cada emissão de passagem feita com suas milhas.</br>A alteração de telefone é uma facilidade a mais para você.</br></br>Por isso, atenção! Se o telefone cadastrado no seu programa de fidelidade for divergente do nosso cadastro, sua oferta não será aprovada."
			confirm="Confirmar"
			cancel="Cancelar"
			width={490}
			height={440}
			onConfirm={onConfirm}
			onCancel={onCancel}
		/>
	);
};

export const VinduloPendenteModal = ({ show, onConfirm }) => {
	return (
		<Modal
			show={show}
			fixed={true}
			title="Atenção"
			description="Neste momento seu vínculo com gestor está pendente. Portanto, não é possível criar ou editar ofertas."
			confirm="Fechar"
			onConfirm={onConfirm}
		/>
	);
};

export const VendaRapidaNaoElegivel = ({ show, onConfirm }) => {
	return (
		<Modal
			show={show}
			fixed={true}
			title="ATENÇÃO"
			description="A Venda Rápida não poderá ser utilizada nesta oferta, mas continue anunciando suas milhas! Vamos direcionar você para nossa Venda Convencional, combinado?"
			confirm="Ok, entendi"
			onConfirm={onConfirm}
		/>
	);
};

export const PagamentoAntecipadoNaoElegivel = ({ show, onConfirm }) => {
	return (
		<Modal
			show={show}
			fixed={true}
			title="ATENÇÃO"
			description="O Pagamento Agendado não poderá ser utilizado nesta oferta, mas continue anunciando suas milhas! Vamos direcionar você para nossa Venda Convencional, combinado?"
			confirm="Ok, entendi"
			onConfirm={onConfirm}
		/>
	);
};

export const MediaVendasModal = ({ show, percent, media, onConfirm, onCancel }) => {
	let msg = `
	<p><strong>Esta média representa apenas ${percent}% das nossas vendas.</strong></p>

	<p>A média selecionada por você é muito alta e sua venda pode demorar a ser feita. Nossa sugestão é que sua média seja ${media} milhas por passageiro.</p>
	
	<p>Você quer prosseguir com esta alteração?</p>
	`;
	return (
		<Modal
			show={show}
			fixed={true}
			title="Atenção"
			description={msg}
			confirm="Continuar"
			cancel="Cancelar"
			width={490}
			onConfirm={onConfirm}
			onCancel={onCancel}
		/>
	);
};

export const AvisoProblemaModal = ({ show, onConfirm }) => {
	return (
		<Modal
			show={show}
			fixed={true}
			title="OFERTA NÃO APROVADA"
			description="Infelizmente sua oferta anterior não foi aprovada. Não será possível cadastrar uma nova oferta para este programa de fidelidade."
			confirm="Fechar"
			onConfirm={onConfirm}
		/>
	);
};

export const AvisoProblemaModalPagamentoAntecipado = ({ show, onConfirm }) => {
	return (
		<Modal
			show={show}
			fixed={true}
			title="Uso das milhas em andamento"
			description="Esta oferta já foi aprovada e suas milhas estão sendo utilizadas em novas emissões de passagens. Por isso, não é possível alterar ou fazer uma nova oferta neste programa de fidelidade até que todas as milhas sejam utilizadas."
			confirm="Fechar"
			onConfirm={onConfirm}
		/>
	);
};

export const CpfsExpiradosModal = ({ show, onCancel, onConfirm }) => {
	return (
		<Modal
			show={show}
			fixed={true}
			title="Mais emissões liberadas"
			description="Você pode fazer novas emissões para passageiros diferentes com esta oferta. Cadastre mais milhas e aproveite!"
			cancel="Voltar"
			confirm="Cadastrar mais milhas"
			onCancel={onCancel}
			onConfirm={onConfirm}
			dataActionConfirm="expired-documents-confirm"
			dataActionCancel="expired-documents-cancel"
		/>
	);
};